// Minimal theme utilities: apply to Vuetify + mirror to CSS variables + optional API

// Accept only hex colours like #123 or #112233
const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

// Keys we’re willing to accept from the API (extend if you use more)
const KEYS = [
  'primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning',
  'grey300', 'grey700', 'grey50', 'grey800', 'calender', 'material50',
  'header', 'partnerHeader', 'directHeader', 'grass'
]

const CACHE_KEY = 'brandTheme:v1'

// Apply a theme override to Vuetify + expose CSS variables
export function applyTheme(vuetifyInstance, override = {}) {
  // Vuetify was seeded with defaults in plugins/vuetify.js.
  // We just update both light/dark and set CSS vars.
  const fw = vuetifyInstance.framework
  const clean = sanitize(override)

  fw.theme.themes.light = { ...fw.theme.themes.light, ...clean }
  fw.theme.themes.dark  = { ...fw.theme.themes.dark,  ...clean }
  if (typeof override.dark === 'boolean') fw.theme.dark = override.dark

    const aliasMap = {
    '--improve-brand-grass': '--brand-grass',
    '--improve-brand-blue': '--brand-primary',
    '--improve-brand-deep-blue': '--brand-primary',
    '--improve-white': '--default-white',
    '--improve-green': '--brand-grass',
    '--improve-navy': '--brand-primary',
    };
    Object.entries(aliasMap).forEach(([alias, target]) => {
    const val = getComputedStyle(document.documentElement).getPropertyValue(target);
    if (val) document.documentElement.style.setProperty(alias, val.trim());
    });
}

function sanitize(input) {
  const out = {}
  for (const k of KEYS) {
    const val = input[k]
    if (typeof val === 'string' && HEX.test(val)) out[k] = val
  }
  return out
}

export function loadCachedTheme() {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function saveCachedTheme(theme) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(theme))
  } catch {}
}

// Fetch theme from your backend when it exists.
// Expected shape: { primary: "#112233", secondary: "#445566", dark: false, ...optional keys }
export async function fetchThemeFromApi() {
  const res = await fetch('/api/theme', { method: 'GET' })
  if (!res.ok) throw new Error('Theme API failed')
  // const data = await res.json()

  const data = { primary: "#5500ff" } // DELETE ME
  const out = {}
  for (const k of KEYS) {
    if (k in data) out[k] = data[k]
  }
  if ('dark' in data) out.dark = !!data.dark
  return out
}